import { getReduxStore } from "../store/state/redux-host.js";
import "../store/state/host.js";
import "../store/state/modal.js";
import { useMemoryData } from "../store/storage/memory-storage.js";
import "mitt";
import { SimpleDataStore } from "../store/storage/simple-data-store.js";
import "../store/storage/universal-memory-storage.js";
import { AwaitableEventEmitter } from "../utils/awaitable-event-emitter.js";
const getEmitter = useMemoryData(
  "beforeAuthenticationSuccessHook",
  () => new SimpleDataStore()
);
function getAccountPortalState() {
  const { getState } = getReduxStore();
  return getState().accountPortal;
}
const beforeAuthenticationSuccess = getOrCreateEmitter();
function getOrCreateEmitter() {
  if (!getEmitter().has()) {
    getEmitter().set(new AwaitableEventEmitter());
  }
  return getEmitter().get();
}
function updateLegacyUserWithSession(user, session) {
  const userSession = user.session || {};
  return {
    ...user,
    isNewUser: user.isNewUser ?? userSession.isNewUser,
    isPersistent: user.isPersistent ?? userSession.isPersistent,
    isSocialLogin: user.isSocialLogin ?? userSession.socialProvider ? true : void 0,
    expirationTimestamp: user.expirationTimestamp ?? userSession.reAuthAfter,
    session: {
      ...user.session,
      isNewUser: userSession.isNewUser ?? user.isNewUser,
      isPersistent: userSession.isPersistent ?? user.isPersistent,
      socialProvider: userSession.socialProvider || (user.isSocialLogin ? "unknown" : void 0),
      reAuthAfter: userSession.reAuthAfter ?? user.expirationTimestamp,
      ...session
    }
  };
}
export {
  beforeAuthenticationSuccess,
  getAccountPortalState,
  updateLegacyUserWithSession
};
//# sourceMappingURL=utils.js.map
